import pako from 'pako';
import Course from "./course"
import Teacher from "./teacher"
import Vote from "./vote"

export default class Lesson {
  readonly id: number
  readonly name: string
  readonly mdBody: string
  readonly video: string
  readonly vimeo: string
  readonly description: string
  readonly courses: Course[]
  readonly teachers: Teacher[]
  readonly lessonType: 'text' | 'video' | 'exam' | 'live'
  readonly updatedAt: Date
  readonly publishedAt: Date | null = null
  readonly image: any
  readonly votes: Vote[] = []
  readonly questionsCount: number
  readonly examId: number = 0
  
  public voteValues: number = 0
  public voteMark = 0;

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.name = data.name
    // this.mdBody = data.mdBody
    this.lessonType = data.lessonType
    this.video = this.lessonType == 'text' ? '' : data.video
    this.description = data.description ?? ''
    this.vimeo = this.lessonType == 'text' ? '' : data.vimeo
    this.image = data.image
    this.updatedAt = new Date(data.updatedAt)
    this.questionsCount = data.questionsCount
    this.voteValues = data.voteValues

    if (data.mdBody) {
      const compressedContent = atob(data.mdBody);
      const byteArray = new Uint8Array(compressedContent.split('').map(char => char.charCodeAt(0)));
      this.mdBody = pako.inflate(byteArray, { to: 'string' })
    }

    if (data.courses) {
      this.courses = data.courses.map((element) => new Course(element))
    }
    if (data.teachers) {
      this.teachers = data.teachers.map(element => new Teacher(element))
    }
    if (data.votes) {
      this.votes = data.votes.map((element) => new Vote(element))
    }
    this.voteMark = this.votes.reduce((sum, vote) => sum + vote.value, 0)
    if (data.publishedAt) {
      this.publishedAt = new Date(data.publishedAt)
    }

    this.examId = data.examId ?? 0
  }

  get imageUrl(){
    return this.image?.url
  }

  get isText(){
    return this.lessonType == 'text'
  }

  get isVideo(){
    return this.lessonType == 'video' || this.lessonType == 'live' || (this.lessonType == null && (this.video || this.vimeo))
  }

  get isExam(){
    return this.lessonType == 'exam'
  }
}
